var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfluence(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.769531 8.45315C0.769531 3.84933 4.50166 0.117188 9.10548 0.117188H32.3957C36.9995 0.117188 40.7316 3.84932 40.7316 8.45314V31.7433C40.7316 36.3471 36.9995 40.0793 32.3957 40.0793H9.10549C4.50167 40.0793 0.769531 36.3471 0.769531 31.7433V8.45315Z",
    fill: "#155DFC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4141_6428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.751 28.4277C25.351 28.4277 29.0801 24.6987 29.0801 20.0986C29.0801 15.4986 25.351 11.7695 20.751 11.7695C16.1509 11.7695 12.4219 15.4986 12.4219 20.0986C12.4219 24.6987 16.1509 28.4277 20.751 28.4277Z",
    stroke: "white",
    strokeWidth: 1.66582,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7514 25.0945C23.5114 25.0945 25.7488 22.8571 25.7488 20.0971C25.7488 17.337 23.5114 15.0996 20.7514 15.0996C17.9913 15.0996 15.7539 17.337 15.7539 20.0971C15.7539 22.8571 17.9913 25.0945 20.7514 25.0945Z",
    stroke: "white",
    strokeWidth: 1.66582,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7518 21.7633C21.6718 21.7633 22.4176 21.0175 22.4176 20.0975C22.4176 19.1775 21.6718 18.4316 20.7518 18.4316C19.8318 18.4316 19.0859 19.1775 19.0859 20.0975C19.0859 21.0175 19.8318 21.7633 20.7518 21.7633Z",
    stroke: "white",
    strokeWidth: 1.66582,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4141_6428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9898,
    height: 19.9898,
    fill: "white",
    transform: "translate(10.7539 10.1035)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfluence);
export default __webpack_public_path__ + "static/media/Influence.5d08e84174b15f0f95a3dc35f7871717.svg";
export { ForwardRef as ReactComponent };